export default "__VITE_ASSET__DiXTdhGC__"